module.exports = __webpack_public_path__ + "static/media/ID.dabbf94d.png";